webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(229),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(149);

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__(153);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(152);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__(144);

var _gt = __webpack_require__(146);

var _gt2 = _interopRequireDefault(_gt);

var _util = __webpack_require__(145);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false,
            checked: false,
            aid: this.$route.query.a,
            clubMask: this.$route.query.c,
            clubName: '',
            mobile: '',
            isMobile: false,
            code: '',
            guild_badge_image: '',
            guild_name: '',
            isOfficial: 0,
            need_confirm: 0,
            settle_type: '',
            settle_type_pw: '',
            clubSharedRatio: [],
            selectIndex: 1,
            verified: false,
            timeHandler: 0,
            countDown: 60,
            icon: '',
            is_new: 0,
            nickname: '',
            roomid: 0,
            send_sms: false,
            success: false
        };
    },

    methods: {
        getClubName: function getClubName() {
            var _this = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _api.getClubNameByCode)({ clubMask: _this.clubMask, aid: _this.aid });

                            case 2:
                                res = _context.sent;

                                if (res.status === 200) {
                                    _this.clubName = res.data.data;
                                }
                                if (!_this.clubName) {}

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        onChanged: function onChanged(val) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var res, data, keys;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.isMobile = _util2.default.isMobile(val);

                                if (!(_this2.isMobile && _this2.clubSharedRatio.length === 0)) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 4;
                                return (0, _api.getGuildInviteInfoByPhone)({ clubMask: _this2.clubMask, mobile: _this2.mobile });

                            case 4:
                                res = _context2.sent;

                                if (res.data.status === 200 && res.data.data.code === 0) {
                                    data = res.data.data.data;

                                    _this2.guild_badge_image = data.guild_badge_image;
                                    _this2.guild_name = data.guild_name;
                                    _this2.isOfficial = data.isOfficial;
                                    _this2.need_confirm = data.need_confirm;
                                    _this2.settle_type = data.settle_type;
                                    _this2.settle_type_pw = data.settle_type_pw;
                                    _this2.clubSharedRatio = [];
                                    keys = (0, _keys2.default)(data.clubSharedRatio);

                                    keys.forEach(function (key) {
                                        var value = data.clubSharedRatio[key];
                                        _this2.clubSharedRatio.push({ key: key, desc: value.desc, ratio: value.ratio, pwRatio: value.pwRatio });
                                    });
                                    _this2.clubSharedRatio.reverse();
                                }

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        handleGetCode: function handleGetCode() {
            this.captchaObj.verify();
        },
        joinClub: function joinClub() {
            var _this3 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var message, res;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                message = '提交失败，请重试';
                                _context3.prev = 1;

                                _this3.loading = true;
                                _context3.next = 5;
                                return (0, _api.validateGuildInviteCode)({ aid: _this3.aid, nickName: _this3.nickname, roomId: _this3.roomid, mobile: _this3.mobile, clubMask: _this3.clubMask, code: ('' + _this3.code).slice(0, 6), period: _this3.clubSharedRatio[_this3.selectIndex].key });

                            case 5:
                                res = _context3.sent;

                                _this3.loading = false;

                                if (!(res.data.status === 200 && res.data.data.code === 0)) {
                                    _context3.next = 13;
                                    break;
                                }

                                _this3.$message({
                                    message: "提交成功，请尽快完成认证",
                                    type: 'success'
                                });
                                _this3.success = true;
                                return _context3.abrupt('return');

                            case 13:
                                if (res.data.status === 200 && res.data.data.code > 0) {
                                    message = res.data.data.msg;
                                }

                            case 14:
                                _context3.next = 20;
                                break;

                            case 16:
                                _context3.prev = 16;
                                _context3.t0 = _context3['catch'](1);

                                console.log(_context3.t0);
                                _this3.loading = false;

                            case 20:
                                _this3.$message({
                                    message: message,
                                    type: 'success'
                                });

                            case 21:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[1, 16]]);
            }))();
        },
        sendCode: function sendCode(challenge, validate, secCode) {
            var _this4 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var res, data;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return (0, _api.sendGuildInviteCode)({ mobile: _this4.mobile, challenge: challenge, validate: validate, secCode: secCode });

                            case 2:
                                res = _context4.sent;

                                if (!(res.data.status === 200 && res.data.data.code === 0)) {
                                    _context4.next = 16;
                                    break;
                                }

                                data = res.data.data.data;

                                _this4.icon = data.icon;
                                _this4.is_new = data.is_new;
                                _this4.nickname = data.nickname;
                                _this4.roomid = data.roomid;
                                _this4.send_sms = data.send_sms;

                                if (!_this4.send_sms) {
                                    _context4.next = 16;
                                    break;
                                }

                                _this4.timeHandler = 0;
                                clearInterval(_this4.timeHandler);
                                _this4.countDown = 60;
                                _this4.timeHandler = setInterval(function () {
                                    _this4.countDown--;
                                    if (_this4.countDown === 0) {
                                        _this4.countDown = 60;
                                        clearInterval(_this4.timeHandler);
                                        _this4.timeHandler = 0;
                                    }
                                }, 1000);
                                return _context4.abrupt('return');

                            case 16:
                                _this4.$message({
                                    message: "验证码发送失败",
                                    type: 'warning'
                                });

                            case 17:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },

        initGeetestByParam: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                var _this5 = this;

                var res, _res$data$data$data, gt, challenge, success;

                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return (0, _api.getGuildInviteGeeStatus)();

                            case 2:
                                res = _context5.sent;

                                if (res.data.status === 200 && res.data.data.code === 0) {
                                    _res$data$data$data = res.data.data.data, gt = _res$data$data$data.gt, challenge = _res$data$data$data.challenge, success = _res$data$data$data.success;

                                    initGeetest({
                                        gt: gt,
                                        challenge: challenge,
                                        offline: !success,
                                        new_captcha: true,
                                        product: "bind",
                                        width: "300px"
                                    }, function (captchaObj) {
                                        _this5.captchaObj = captchaObj;
                                        captchaObj.onReady(function () {}).onSuccess(function () {
                                            _this5.verified = true;
                                            var res = _this5.captchaObj.getValidate();
                                            if (!res) {
                                                return;
                                            }
                                            var challenge = res.geetest_challenge,
                                                validate = res.geetest_validate,
                                                secCode = res.geetest_seccode;

                                            _this5.sendCode(challenge, validate, secCode);
                                        }).onError(function () {
                                            _this5.verified = false;
                                        });
                                    });
                                }

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function initGeetestByParam() {
                return _ref.apply(this, arguments);
            }

            return initGeetestByParam;
        }()
    },
    mounted: function mounted() {
        this.initGeetestByParam();
        this.getClubName();
        document.title = '欢迎加入';
    }
};

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateGuildInviteCode = exports.sendGuildInviteCode = exports.getGuildInviteGeeStatus = exports.getGuildInviteInfoByPhone = exports.getClubNameByCode = undefined;

var _promise = __webpack_require__(68);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(125);

var _axios2 = _interopRequireDefault(_axios);

var _elementUi = __webpack_require__(57);

var _elementUi2 = _interopRequireDefault(_elementUi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var err403 = 0;

_axios2.default.defaults.params = {};
_axios2.default.interceptors.request.use(function (config) {
  if (false) {
    config.params['orgMask'] = 'dJ22oOO';
  }
  return config;
}, function (error) {
  return _promise2.default.reject(error);
});

_axios2.default.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return _promise2.default.reject(error);
});

var base =  true ? 'https://oa.casten.cn/api' : 'http://127.0.0.1:8001/api';

var getClubNameByCode = exports.getClubNameByCode = function getClubNameByCode(params) {
  return _axios2.default.get(base + '/club/name', { params: params });
};

var getGuildInviteInfoByPhone = exports.getGuildInviteInfoByPhone = function getGuildInviteInfoByPhone(params) {
  return _axios2.default.get(base + '/anchor/getGuildInviteInfoByPhone', { params: params });
};

var getGuildInviteGeeStatus = exports.getGuildInviteGeeStatus = function getGuildInviteGeeStatus(params) {
  return _axios2.default.get(base + '/anchor/getGuildInviteGeeStatus', { params: params });
};

var sendGuildInviteCode = exports.sendGuildInviteCode = function sendGuildInviteCode(params) {
  return _axios2.default.get(base + '/anchor/sendGuildInviteCode', { params: params });
};

var validateGuildInviteCode = exports.validateGuildInviteCode = function validateGuildInviteCode(params) {
  return _axios2.default.get(base + '/anchor/validateGuildInviteCode', { params: params });
};

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    isMobile: function isMobile(mobile) {
        var reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!reg.test(mobile)) {
            return false;
        } else {
            return true;
        }
    },
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {
        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }
    },
    formatFileSize: function formatFileSize(value) {
        if (null == value || value == '') {
            return "0 Bytes";
        }
        var unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
        var index = 0;
        var srcsize = parseFloat(value);
        index = Math.floor(Math.log(srcsize) / Math.log(1024));
        var size = srcsize / Math.pow(1024, index);
        size = size.toFixed(2);
        return size + unitArr[index];
    },
    maskString: function maskString(start, end, value) {
        var fill = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '*';

        if (value && typeof value === 'string' && value.length > start + end) {
            var ret = value.split('');
            var length = value.length - (start + end);
            var mask = new Array(length).join(fill);
            ret.splice(start, length, mask);
            return ret.join('');
        }
        return value;
    },
    mixTextOverflow: function mixTextOverflow(text, length) {
        if (text.replace(/[\u4e00-\u9fa5]/g, 'aa').length <= length) {
            return text;
        } else {
            var _length = 0;
            var outputText = '';
            for (var i = 0; i < text.length; i++) {
                if (/[\u4e00-\u9fa5]/.test(text[i])) {
                    _length += 2;
                } else {
                    _length += 1;
                }
                if (_length > length) {
                    break;
                } else {
                    outputText += text[i];
                }
            }
            return outputText + '...';
        }
    },
    getLeftTime: function getLeftTime(lasttime) {
        if (lasttime > 0) {
            var lastdate = parseInt(lasttime / 3600 / 24);
            var lasthours = parseInt(lasttime / 3600 % 24);
            var lastminutes = parseInt(lasttime / 60 % 60);
            return '剩余' + lastdate + '天' + lasthours + '时' + lastminutes + '分';
        }
    },
    getPreMonth: function getPreMonth(date) {
        var arr = date.split('-');
        var year = arr[0];
        var month = arr[1];
        var day = arr[2];
        var days = new Date(year, month, 0);
        days = days.getDate();
        var year2 = year;
        var month2 = parseInt(month) - 1;
        if (month2 == 0) {
            year2 = parseInt(year2) - 1;
            month2 = 12;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
            day2 = days2;
        }
        if (month2 < 10) {
            month2 = '0' + month2;
        }
        var t2 = year2 + '-' + month2 + '-' + day2;
        return t2;
    }
};

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"v0.4.8 Geetest Inc.";

var _typeof2 = __webpack_require__(19);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (window) {
    "use strict";

    if (typeof window === 'undefined') {
        throw new Error('Geetest requires browser environment');
    }

    var document = window.document;
    var Math = window.Math;
    var head = document.getElementsByTagName("head")[0];

    function _Object(obj) {
        this._obj = obj;
    }

    _Object.prototype = {
        _each: function _each(process) {
            var _obj = this._obj;
            for (var k in _obj) {
                if (_obj.hasOwnProperty(k)) {
                    process(k, _obj[k]);
                }
            }
            return this;
        }
    };

    function Config(config) {
        var self = this;
        new _Object(config)._each(function (key, value) {
            self[key] = value;
        });
    }

    Config.prototype = {
        api_server: 'api.geetest.com',
        protocol: 'http://',
        typePath: '/gettype.php',
        fallback_config: {
            slide: {
                static_servers: ["static.geetest.com", "dn-staticdown.qbox.me"],
                type: 'slide',
                slide: '/static/js/geetest.0.0.0.js'
            },
            fullpage: {
                static_servers: ["static.geetest.com", "dn-staticdown.qbox.me"],
                type: 'fullpage',
                fullpage: '/static/js/fullpage.0.0.0.js'
            }
        },
        _get_fallback_config: function _get_fallback_config() {
            var self = this;
            if (isString(self.type)) {
                return self.fallback_config[self.type];
            } else if (self.new_captcha) {
                return self.fallback_config.fullpage;
            } else {
                return self.fallback_config.slide;
            }
        },
        _extend: function _extend(obj) {
            var self = this;
            new _Object(obj)._each(function (key, value) {
                self[key] = value;
            });
        }
    };
    var isNumber = function isNumber(value) {
        return typeof value === 'number';
    };
    var isString = function isString(value) {
        return typeof value === 'string';
    };
    var isBoolean = function isBoolean(value) {
        return typeof value === 'boolean';
    };
    var isObject = function isObject(value) {
        return (typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === 'object' && value !== null;
    };
    var isFunction = function isFunction(value) {
        return typeof value === 'function';
    };
    var MOBILE = /Mobi/i.test(navigator.userAgent);
    var pt = MOBILE ? 3 : 0;

    var callbacks = {};
    var status = {};

    var nowDate = function nowDate() {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();

        if (month >= 1 && month <= 9) {
            month = '0' + month;
        }
        if (day >= 0 && day <= 9) {
            day = '0' + day;
        }
        if (hours >= 0 && hours <= 9) {
            hours = '0' + hours;
        }
        if (minutes >= 0 && minutes <= 9) {
            minutes = '0' + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
            seconds = '0' + seconds;
        }
        var currentdate = year + '-' + month + '-' + day + " " + hours + ":" + minutes + ":" + seconds;
        return currentdate;
    };

    var random = function random() {
        return parseInt(Math.random() * 10000) + new Date().valueOf();
    };

    var loadScript = function loadScript(url, cb) {
        var script = document.createElement("script");
        script.charset = "UTF-8";
        script.async = true;

        if (/static\.geetest\.com/g.test(url)) {
            script.crossOrigin = "anonymous";
        }

        script.onerror = function () {
            cb(true);
        };
        var loaded = false;
        script.onload = script.onreadystatechange = function () {
            if (!loaded && (!script.readyState || "loaded" === script.readyState || "complete" === script.readyState)) {

                loaded = true;
                setTimeout(function () {
                    cb(false);
                }, 0);
            }
        };
        script.src = url;
        head.appendChild(script);
    };

    var normalizeDomain = function normalizeDomain(domain) {
        return domain.replace(/^https?:\/\/|\/$/g, '');
    };
    var normalizePath = function normalizePath(path) {
        path = path.replace(/\/+/g, '/');
        if (path.indexOf('/') !== 0) {
            path = '/' + path;
        }
        return path;
    };
    var normalizeQuery = function normalizeQuery(query) {
        if (!query) {
            return '';
        }
        var q = '?';
        new _Object(query)._each(function (key, value) {
            if (isString(value) || isNumber(value) || isBoolean(value)) {
                q = q + encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
            }
        });
        if (q === '?') {
            q = '';
        }
        return q.replace(/&$/, '');
    };
    var makeURL = function makeURL(protocol, domain, path, query) {
        domain = normalizeDomain(domain);

        var url = normalizePath(path) + normalizeQuery(query);
        if (domain) {
            url = protocol + domain + url;
        }

        return url;
    };

    var load = function load(config, send, protocol, domains, path, query, cb) {
        var tryRequest = function tryRequest(at) {

            var url = makeURL(protocol, domains[at], path, query);
            loadScript(url, function (err) {
                if (err) {
                    if (at >= domains.length - 1) {
                        cb(true);

                        if (send) {
                            config.error_code = 508;
                            var url = protocol + domains[at] + path;
                            reportError(config, url);
                        }
                    } else {
                        tryRequest(at + 1);
                    }
                } else {
                    cb(false);
                }
            });
        };
        tryRequest(0);
    };

    var jsonp = function jsonp(domains, path, config, callback) {
        if (isObject(config.getLib)) {
            config._extend(config.getLib);
            callback(config);
            return;
        }
        if (config.offline) {
            callback(config._get_fallback_config());
            return;
        }

        var cb = "geetest_" + random();
        window[cb] = function (data) {
            if (data.status == 'success') {
                callback(data.data);
            } else if (!data.status) {
                callback(data);
            } else {
                callback(config._get_fallback_config());
            }
            window[cb] = undefined;
            try {
                delete window[cb];
            } catch (e) {}
        };
        load(config, true, config.protocol, domains, path, {
            gt: config.gt,
            callback: cb
        }, function (err) {
            if (err) {
                callback(config._get_fallback_config());
            }
        });
    };

    var reportError = function reportError(config, url) {
        load(config, false, config.protocol, ['monitor.geetest.com'], '/monitor/send', {
            time: nowDate(),
            captcha_id: config.gt,
            challenge: config.challenge,
            pt: pt,
            exception_url: url,
            error_code: config.error_code
        }, function (err) {});
    };

    var throwError = function throwError(errorType, config) {
        var errors = {
            networkError: '网络错误',
            gtTypeError: 'gt字段不是字符串类型'
        };
        if (typeof config.onError === 'function') {
            config.onError(errors[errorType]);
        } else {
            throw new Error(errors[errorType]);
        }
    };

    var detect = function detect() {
        return window.Geetest || document.getElementById("gt_lib");
    };

    if (detect()) {
        status.slide = "loaded";
    }

    window.initGeetest = function (userConfig, callback) {

        var config = new Config(userConfig);

        if (userConfig.https) {
            config.protocol = 'https://';
        } else if (!userConfig.protocol) {
            config.protocol = window.location.protocol + '//';
        }

        if (userConfig.gt === '050cffef4ae57b5d5e529fea9540b0d1' || userConfig.gt === '3bd38408ae4af923ed36e13819b14d42') {
            config.apiserver = 'yumchina.geetest.com/';
            config.api_server = 'yumchina.geetest.com';
        }

        if (userConfig.gt) {
            window.GeeGT = userConfig.gt;
        }

        if (userConfig.challenge) {
            window.GeeChallenge = userConfig.challenge;
        }

        if (isObject(userConfig.getType)) {
            config._extend(userConfig.getType);
        }
        jsonp([config.api_server || config.apiserver], config.typePath, config, function (newConfig) {
            var type = newConfig.type;
            var init = function init() {
                config._extend(newConfig);
                callback(new window.Geetest(config));
            };

            callbacks[type] = callbacks[type] || [];
            var s = status[type] || 'init';
            if (s === 'init') {
                status[type] = 'loading';

                callbacks[type].push(init);

                load(config, true, config.protocol, newConfig.static_servers || newConfig.domains, newConfig[type] || newConfig.path, null, function (err) {
                    if (err) {
                        status[type] = 'fail';
                        throwError('networkError', config);
                    } else {
                        status[type] = 'loaded';
                        var cbs = callbacks[type];
                        for (var i = 0, len = cbs.length; i < len; i = i + 1) {
                            var cb = cbs[i];
                            if (isFunction(cb)) {
                                cb();
                            }
                        }
                        callbacks[type] = [];
                    }
                });
            } else if (s === "loaded") {
                init();
            } else if (s === "fail") {
                throwError('networkError', config);
            } else if (s === "loading") {
                callbacks[type].push(init);
            }
        });
    };
})(window);

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(101);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(57);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(98);

__webpack_require__(100);

var _vueRouter = __webpack_require__(102);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _routes = __webpack_require__(97);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
    routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
    console.log(to);
    if (to.path !== '/') {
        next({ path: '/', params: to.params });
    } else {
        next();
    }
});

new _vue2.default({
    router: router,
    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(228),
  /* scopeId */
  "data-v-082d9fb6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 228:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    staticClass: "login-container",
    attrs: {
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "express-form-wrap"
  }, [_c('h3', {
    staticClass: "guild-name"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("公会名：" + _vm._s(_vm.clubName))])]), _vm._v(" "), (!_vm.success) ? _c('div', {
    staticClass: "form-wrap"
  }, [(_vm.clubSharedRatio.length > 0) ? _c('div', [(_vm.nickname) ? _c('div', {
    staticClass: "info-wrap mr-20"
  }, [_c('div', {
    staticClass: "anchor-info"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": ("https:" + _vm.icon),
      "alt": "主播头像"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "anchor-room"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', {
    staticClass: "lable"
  }, [_vm._v("昵称：")]), _vm._v(_vm._s(_vm.nickname) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [(_vm.roomid <= 0) ? _c('div', {
    staticClass: "tips-title"
  }, [_vm._v("您还不是主播~")]) : _c('div', {
    staticClass: "tips-title2"
  }, [_vm._v("房间号: " + _vm._s(_vm.roomid))]), _vm._v(" "), _c('div', {
    staticClass: "tips-txt"
  }, [_vm._v("请确保提交申请后24小时完成实名认证，否则申请无效")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-wrap"
  }, [_c('div', {
    staticClass: "sign-info"
  }, [_c('h2', {
    staticClass: "sign-info-title"
  }, [_vm._v("您确定与该公会签约吗？")]), _vm._v(" "), _c('div', {
    staticClass: "guild-sign"
  }, [_c('img', {
    staticClass: "guild-avatar",
    attrs: {
      "src": _vm.guild_badge_image,
      "alt": "公会头像"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "guild-sign-info"
  }, [_c('table', [_c('tbody', [_c('tr', {
    staticClass: "sign-info-row"
  }, [_c('td', {
    staticClass: "opt-name"
  }, [_vm._v("签约公会：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_c('span', {
    staticClass: "sign-guild-name",
    attrs: {
      "title": _vm.guild_name
    }
  }, [_vm._v(_vm._s(_vm.guild_name))])])]), _vm._v(" "), _c('tr', {
    staticClass: "sign-info-row"
  }, [_c('td', {
    staticClass: "opt-name"
  }, [_vm._v("签约时长：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_c('el-select', {
    model: {
      value: (_vm.selectIndex),
      callback: function($$v) {
        _vm.selectIndex = $$v
      },
      expression: "selectIndex"
    }
  }, _vm._l((_vm.clubSharedRatio), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.desc,
        "value": index
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('tr', {
    staticClass: "sign-info-row"
  }, [_c('td', {
    staticClass: "opt-name"
  }, [_vm._v("主播礼物提成：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_c('span', {
    staticClass: "ratio",
    attrs: {
      "id": "anchor-ratio"
    }
  }, [_vm._v(_vm._s(100 - _vm.clubSharedRatio[_vm.selectIndex].ratio) + "%")])]), _vm._v(" "), _c('td', {
    staticClass: "opt-name"
  }, [_vm._v("礼物收益结算：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_vm._v(_vm._s(_vm.settle_type === 1 ? "对公结算" : '对私结算'))])]), _vm._v(" "), _c('tr', {
    staticClass: "sign-info-row"
  }, [_c('td', {
    staticClass: "opt-name"
  }, [_vm._v("主播陪玩提成：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_c('span', {
    staticClass: "ratio",
    attrs: {
      "id": "anchor-pw-ratio"
    }
  }, [_vm._v(_vm._s(100 - _vm.clubSharedRatio[_vm.selectIndex].pwRatio) + "%")])]), _vm._v(" "), _c('td', {
    staticClass: "opt-name"
  }, [_vm._v("陪玩订单结算：")]), _vm._v(" "), _c('td', {
    staticClass: "opt-desc"
  }, [_vm._v(_vm._s(_vm.settle_type_pw === 1 ? "对公结算" : '对私结算'))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "guild-desc"
  }, [_c('p', {
    staticClass: "guild-desc-row"
  }, [_c('span', {
    staticClass: "desc-name"
  }, [_vm._v("对公结算：")]), _vm._v(" "), _c('span', {
    staticClass: "desc-remark"
  }, [_vm._v("主播收益在结算时，全部计入签约公会的对公账户，由公会统一代为扣税后再分配给主播。")])]), _vm._v(" "), _c('p', {
    staticClass: "guild-desc-row"
  }, [_c('span', {
    staticClass: "desc-name"
  }, [_vm._v("对私结算：")]), _vm._v(" "), _c('span', {
    staticClass: "desc-remark"
  }, [_vm._v("主播收益在结算时，按公会抽成比例分别计算主播和公会所得，主播所得计入主播的个人账户，提现时将扣除相关费用。")])]), _vm._v(" "), _c('p', {
    staticClass: "guild-desc-row"
  }, [_c('span', {
    staticClass: "desc-name attention"
  }, [_vm._v("注意：")]), _vm._v(" "), _c('span', {
    staticClass: "desc-remark"
  }, [_vm._v("与公会签约期间，严禁您使用其他帐号进行表演。一旦发现，官方有权禁止此帐号在斗鱼平台进行表演。")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rowwrap"
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "400px",
      "margin-left": "40px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号码",
      "clearable": ""
    },
    on: {
      "input": _vm.onChanged,
      "clear": function($event) {
        this.mobile = ''
      }
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "400px",
      "margin-left": "40px"
    }
  }, [_c('el-input', {
    attrs: {
      "oninput": "if(value.length > 6) value = value.slice(0, 6)",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = _vm._n($$v)
      },
      expression: "code"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('el-button', {
    class: _vm.isMobile ? 'enableButton' : 'disableButton',
    staticStyle: {
      "width": "102px"
    },
    attrs: {
      "disabled": !_vm.isMobile || this.timeHandler > 0
    },
    on: {
      "click": _vm.handleGetCode
    }
  }, [_vm._v(_vm._s(this.timeHandler > 0 ? this.countDown : '获取验证码'))])], 1)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rowwrap protocal-wrap"
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-right": "2px"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "protocol",
      "id": "protocal-label"
    }
  }, [_c('p', {
    staticClass: "protocal-text"
  }, [_c('span', [_vm._v("我已阅读且同意")]), _c('a', {
    attrs: {
      "href": "//www.douyu.com/protocal/roomclub",
      "target": "_blank"
    }
  }, [_vm._v("斗鱼公会主播入驻服务协议")]), _vm._v("、"), _c('a', {
    attrs: {
      "href": "//www.douyu.com/cms/zhibo/201907/30/6261.shtml",
      "target": "_blank"
    }
  }, [_vm._v("公会主播疑难解答")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "rowwrap foot-wrap"
  }, [_c('el-button', {
    class: !_vm.checked || ("" + _vm.code).length < 6 || _vm.loading || !_vm.send_sms ? 'disableButton' : 'enableButton',
    staticStyle: {
      "width": "420px",
      "height": "40px"
    },
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.checked || ("" + _vm.code).length < 6 || _vm.loading || !_vm.send_sms
    },
    on: {
      "click": _vm.joinClub
    }
  }, [_vm._v("加入公会")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "foot-tips"
  }, [_vm._v("温馨提示：请确保在提交申请后24小时内完成实名认证，否则申请无效")])])])
},staticRenderFns: []}

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Invite = __webpack_require__(227);

var _Invite2 = _interopRequireDefault(_Invite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/',
    component: _Invite2.default,
    name: '',
    hidden: true,
    leaf: true }, {
    path: '*',
    hidden: true,
    redirect: { path: '/' }
}];

exports.default = routes;

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[147]);


// WEBPACK FOOTER //
// static/js/app.4b594e7c53db2844fa71.js